import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { Route, Routes } from "react-router-dom";
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import * as AccountStore from "../account/AccountStore";
import { ManageExternalClient } from "../clients/ManageExternalClient";
import ClientPermissions from "../clients/ClientPermissions";
import ClientSecrets from "../clients/ClientSecrets";
import ClientsTable from "../clients/ClientsTable";
import { DeleteClient, GetClient } from "../clients/ClientStore";
import CreateClient from "../clients/Create";
import EditClient, { Client } from "../clients/Edit";
import { alert } from "../general/alertStore.js";
import { GetContext, UnsubscribeContext } from "../general/ApplicationContext";
import { SquareButton2 } from "../general/SquareButton2";
import * as PermissionStore from "../identityPermissions/IdentityPermissionStore";
import CreateIdentityProvider, { IdentityProviderTypes } from "../identityProviders/Create";
import { DeleteIdentityProvider, UpdateIdentityProvider } from "../identityProviders/IdentityProviderStore";
import Integrations from "../integrations/Integrations";
import OrganizationContextSwitcher from "../organizations/ContextSwitcher";
import CreateOrganization from "./Create";
import OrganizationBranding from "./OrganizationBranding";
import OrganizationCommunication from "./OrganizationCommunication";
import OrganizationManagedServices from "./OrganizationManagedServices";
import OrganizationMembership from "./OrganizationMembership";
import OrganizationRegistrationLinks from "./OrganizationRegistrationLinks";
import { getOrganization, updateOrganization } from "./OrganizationStore";
import OrganizationUserPermissions from "./OrganizationUserPermissions";

const { Component } = React;

interface OrganizationIndexState {
    selectedOrganization: any;
    showCreateModal: boolean;
    showCreateClientModal: boolean;
    showEditClientModal: boolean;
    showIdentityProviderModal: boolean;
    currentClient?: Client;
    policies: any;
    currentUser: any;
}

class Organization {
    id: string;
    name: string;
    defaultDomain: string;
    scadsysOnlineSchoolID: string;
    constructor() {
        this.id = "";
        this.name = "";
        this.defaultDomain = "";
        this.scadsysOnlineSchoolID = "";
    }
}

let contextSubscriptionId = "";

export const Tabs = [
    { permission: "manageOrganizations", route: "/organizations/information", icon: ["fad", "square-info"], name: "Information", description: "Update organization details" },
    { permission: "manageClients", route: "/organizations/clients", icon: ["fad", "sitemap"], name: "Clients", description: "Manage external applications' authentication" },
    {
        permission: "manageOrganizationRegistration",
        route: "/organizations/registration",
        icon: ["fad", "user-plus"],
        name: "Registration",
        description: "Registration links and third-party providers",
    },
    {
        permission: "executeIntegrations",
        route: "/organizations/integrations",
        icon: ["fad", "diagram-project"],
        name: "Integrations",
        description: "Manage and run third-party integrations",
    },
    { permission: "manageOrganizationMembership", route: "/organizations/membership", icon: ["fad", "users"], name: "Membership", description: "View existing user membership" },
    // remove list policies policy
    { permission: "listPolicies", route: "/organizations/permissions", icon: ["fad", "users-gear"], name: "Permissions", description: "User access management" },
    {
        permission: "listManagedServices",
        route: "/organizations/managedServices",
        icon: ["fad", "gears"],
        name: "Managed Services",
        description: "Create and connect managed service applications",
    },
    { permission: "manageOrganizationCommunication", route: "/organizations/communication", icon: ["fad", "phone"], name: "Communication", description: "Send emails" },
    { permission: "manageOrganizationBranding", route: "/organizations/branding", icon: ["fad", "palette"], name: "Branding", description: "Customize branding and colors" },
];

function GetTab(location) {
    let tab = Tabs.filter((t) => t.route == location)[0];

    return tab;
}

export default class OrganizationIndex extends Component<{ navigate: any; location: any }, OrganizationIndexState> {
    constructor(props) {
        super(props);
        this.state = {
            selectedOrganization: undefined,
            showCreateModal: false,
            showCreateClientModal: false,
            showEditClientModal: false,
            showIdentityProviderModal: false,
            policies: undefined,
            currentUser: undefined,
        };
    }

    hasPermission(permission) {
        if (this.state.currentUser && this.state.policies) {
            if (this.state.currentUser.claims.filter((c) => c.type == "http://schemas.microsoft.com/ws/2008/06/identity/claims/role" && c.value == "Admin").length > 0) {
                return true;
            } else {
                return this.state.policies.filter((policy) => policy.permission == permission).length > 0;
            }
        }
        return false;
    }

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            AccountStore.GetCurrentLoggedInUser().then((user) => {
                this.setState({ currentUser: user });
            });
            PermissionStore.GetMyPermissions().then((response) => {
                this.setState({ policies: response.data });
            });
            this.handleChange(context.currentOrganization.id);
        });
        // this.selectTab(Tabs[0], 0)();
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    handleChange = (organization) => {
        if (organization) {
            getOrganization(organization)
                .then((result) => {
                    this.setState({ selectedOrganization: result });
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        let org = new Organization();
                        org.name = "Access Denied";
                        this.setState({ selectedOrganization: org });
                    }
                });
        } else {
            this.setState({
                selectedOrganization: undefined,
            });
        }
    };

    handleNameChange = (e) => {
        var name = e.target.value;

        this.setState((prevState) => {
            prevState.selectedOrganization.name = name;

            return prevState;
        });
    };

    handleScadsysWebRefChange = (e) => {
        var ref = e.target.value;

        this.setState((prevState) => {
            prevState.selectedOrganization.scadsysOnlineSchoolID = ref;

            return prevState;
        });
    };

    handleDomainChange = (e) => {
        var name = e.target.value;

        this.setState((prevState) => {
            prevState.selectedOrganization.defaultDomain = name;

            return prevState;
        });
    };

    handleLogoChange = (e) => {
        var logo = e.target.value;

        this.setState((prevState) => {
            prevState.selectedOrganization.logoUri = logo;

            return prevState;
        });
    };

    handleShortCodeChange = (e) => {
        var shortCode = e.target.value;

        this.setState((prevState) => {
            prevState.selectedOrganization.shortCode = shortCode;

            return prevState;
        });
    };

    handleAllowEmailLoginChange = (e) => {
        var value = e.target.checked;

        this.setState((prevState) => {
            prevState.selectedOrganization.allowEmailLogin = value;

            return prevState;
        });
    };

    toggleCreateModal = () => {
        this.setState((prevState) => ({
            showCreateModal: !prevState.showCreateModal,
        }));
    };

    toggleCreateClientModal = () => {
        if (this.state.showCreateClientModal) {
            this.handleChange(this.state.selectedOrganization.id);
        }
        this.setState((prevState) => ({
            showCreateClientModal: !prevState.showCreateClientModal,
        }));
    };

    toggleIdentityProviderModal = () => {
        if (this.state.showIdentityProviderModal) {
            this.handleChange(this.state.selectedOrganization.id);
        }
        this.setState((prevState) => ({
            showIdentityProviderModal: !prevState.showIdentityProviderModal,
        }));
    };

    updateOrganization = () => {
        return updateOrganization(this.state.selectedOrganization.id, this.state.selectedOrganization).then(
            () => {},
            (error) => {
                alert(error.message);
            }
        );
    };

    deleteIdentityProvider = (id) => {
        DeleteIdentityProvider(id).then(() => {
            this.handleChange(this.state.selectedOrganization.id);
        });
    };

    updateIdentityProvider = (idp) => {
        UpdateIdentityProvider(idp).then(() => {
            getOrganization(this.state.selectedOrganization.id).then((result) => {
                this.setState({ selectedOrganization: result });
            });
        });
    };

    Information = () => {
        return (
            this.hasPermission("manageOrganizations") && (
                <div>
                    <div className="form-group">
                        <label className="col-form-label">ID</label>
                        <div className="p-2" style={{ maxWidth: "300px" }}>
                            {this.state.selectedOrganization.id}
                        </div>
                    </div>
                    <div className="form-group ">
                        <label className="col-form-label">Name</label>
                        <div style={{ maxWidth: "300px" }}>
                            <input type="text" className="form-control" onChange={this.handleNameChange} value={this.state.selectedOrganization.name || ""} />
                        </div>
                    </div>
                    <div className="form-group ">
                        <label className="col-form-label">Scadsys Online School ID</label>
                        <div style={{ maxWidth: "300px" }}>
                            <input type="text" className="form-control" onChange={this.handleScadsysWebRefChange} value={this.state.selectedOrganization.scadsysOnlineSchoolID || ""} />
                        </div>
                    </div>
                    <div className="form-group ">
                        <label className="col-form-label">Default Domain</label>
                        <div style={{ maxWidth: "300px" }}>
                            <input type="text" className="form-control" onChange={this.handleDomainChange} value={this.state.selectedOrganization.defaultDomain || ""} />
                        </div>
                    </div>
                    <div className="form-group ">
                        <label className="col-form-label">Logo URI</label>
                        <div style={{ maxWidth: "300px" }}>
                            <input type="text" className="form-control" onChange={this.handleLogoChange} value={this.state.selectedOrganization.logoUri || ""} />
                        </div>
                    </div>
                    <div className="form-group ">
                        <label className="col-form-label">Short Code</label>
                        <div style={{ maxWidth: "300px" }}>
                            <input type="text" className="form-control" onChange={this.handleShortCodeChange} value={this.state.selectedOrganization.shortCode || ""} />
                        </div>
                    </div>
                    <FormGroup check>
                        <Input type="switch" id={"allowEmailLoginLinks"} checked={this.state.selectedOrganization.allowEmailLogin || false} onChange={this.handleAllowEmailLoginChange} />
                        <Label for={"allowEmailLoginLinks"} check>
                            Allow Email Login Links
                        </Label>
                    </FormGroup>
                    <div className="">
                        <button type="button" className="btn btn-primary" onClick={this.updateOrganization}>
                            Update
                        </button>
                    </div>
                </div>
            )
        );
    };

    Registration = () => {
        return (
            this.hasPermission("manageOrganizationRegistration") && (
                <>
                    {this.hasPermission("manageIdentityProviders") && (
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Source ID</th>
                                    <th>Priority</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.selectedOrganization.identityProviders &&
                                    this.state.selectedOrganization.identityProviders.map((identityProvider, i) => (
                                        <tr key={i}>
                                            <td>{IdentityProviderTypes[identityProvider.type]}</td>
                                            <td>{identityProvider.sourceID}</td>
                                            <td>{identityProvider.priority}</td>
                                            <td>
                                                <button type="button" className="btn btn-outline-danger" style={{ marginRight: "1rem" }} onClick={() => this.deleteIdentityProvider(identityProvider.id)}>
                                                    <FontAwesomeIcon icon={["fad", "trash"]}></FontAwesomeIcon>
                                                </button>
                                                {identityProvider.type == 0 && (
                                                    <Button color="primary" outline={!identityProvider.automaticRegistration} onClick={() => this.updateIdentityProvider({ ...identityProvider, automaticRegistration: !identityProvider.automaticRegistration })}>
                                                        Auto Registration
                                                    </Button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                <tr>
                                    <td colSpan={4}>
                                        <a href="#" onClick={this.toggleIdentityProviderModal}>
                                            Add new Identity Providers
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                    <OrganizationRegistrationLinks organization={this.state.selectedOrganization.id}></OrganizationRegistrationLinks>
                </>
            )
        );
    };

    Integrations = () => {
        return this.hasPermission("executeIntegrations") && <Integrations organization={this.state.selectedOrganization.id}></Integrations>;
    };
    Membership = () => {
        return this.hasPermission("manageOrganizationMembership") && <OrganizationMembership organization={this.state.selectedOrganization.id}></OrganizationMembership>;
    };
    Permissions = () => {
        return this.hasPermission("listPolicies") && <OrganizationUserPermissions organization={this.state.selectedOrganization.id}></OrganizationUserPermissions>;
    };

    ManagedServices = () => {
        return this.hasPermission("listManagedServices") && <OrganizationManagedServices></OrganizationManagedServices>;
    };
    Communication = () => {
        return this.hasPermission("manageOrganizationCommunication") && <OrganizationCommunication organization={this.state.selectedOrganization.id}></OrganizationCommunication>;
    };
    Branding = () => {
        return this.hasPermission("manageOrganizationBranding") && <OrganizationBranding organization={this.state.selectedOrganization.id}></OrganizationBranding>;
    };

    TabHeading = () => {
        let tab = GetTab(this.props.location.pathname);
        return (
            tab && (
                <>
                    {/* @ts-ignore */}
                    <FontAwesomeIcon className="mx-2" icon={tab.icon}></FontAwesomeIcon>
                    {tab.name}
                </>
            )
        );
    };

    render() {
        return (
            <div>
                <OrganizationContextSwitcher></OrganizationContextSwitcher>
                {this.hasPermission("createOrganizations") && (
                    <div className="p-2">
                        <Button outline color="primary" onClick={this.toggleCreateModal}>
                            <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon> Add Organization
                        </Button>
                    </div>
                )}
                {!this.state.selectedOrganization && <div>No Organization Selected</div>}
                {this.state.selectedOrganization && (
                    <>
                        <div className="p-2">
                            <div className="p2">
                                <div className="p-2">
                                    {this.state.selectedOrganization.logoUri && <img className="pl-2" src={this.state.selectedOrganization.logoUri} alt="" style={{ height: "75px" }} />}
                                    <h2 className="pl-2">
                                        {this.state.selectedOrganization.name || "Unknown Organization"}{" "}
                                        {/* <Button
                                            size="lg"
                                            color="link"
                                            onClick={() => {
                                                this.setState({ navOpen: true });
                                            }}
                                            style={{
                                                top: "-3px",
                                                position: "relative",
                                            }}
                                        >
                                            <FontAwesomeIcon className="me-1" size="lg" icon={["fad", "bars"]}></FontAwesomeIcon>
                                            Menu
                                        </Button> */}
                                    </h2>
                                </div>
                            </div>

                            {/* <Modal isOpen={this.state.navOpen} centered={true}>
                                <ModalHeader toggle={this.toggleNavOpen}>Menu</ModalHeader>
                                <ModalBody>
                                   
                                </ModalBody>
                            </Modal> */}

                            <h4>{this.TabHeading()}</h4>
                            <Routes>
                                <Route
                                    path="/"
                                    element={
                                        <Row>
                                            {Tabs.map((tab, i) => (
                                                <Col xs="12" sm="6" lg="4" key={tab.name} onClick={() => this.props.navigate(tab.route)}>
                                                    <SquareButton2 icon={tab.icon} text={tab.name} description={tab.description}></SquareButton2>
                                                </Col>
                                            ))}
                                        </Row>
                                    }
                                ></Route>
                                <Route path="/information" element={this.Information()}></Route>
                                <Route path="/clients" element={<ClientsTable user={this.state.currentUser} organization={this.state.selectedOrganization} policies={this.state.policies} toggleCreateClientModal={this.toggleCreateClientModal}></ClientsTable>}></Route>
                                <Route path="/clients/:id/secrets" element={<ClientSecrets user={this.state.currentUser} policies={this.state.policies}></ClientSecrets>}></Route>
                                <Route path="/clients/:id/permissions" element={<ClientPermissions user={this.state.currentUser} policies={this.state.policies}></ClientPermissions>}></Route>
                                <Route path="/clients/manageExternal" element={<ManageExternalClient user={this.state.currentUser} policies={this.state.policies}></ManageExternalClient>}></Route>
                                <Route path="/registration" element={this.Registration()}></Route>
                                <Route path="/integrations" element={this.Integrations()}></Route>
                                <Route path="/membership" element={this.Membership()}></Route>
                                <Route path="/permissions" element={this.Permissions()}></Route>
                                <Route path="/managedServices" element={this.ManagedServices()}></Route>
                                <Route path="/communication" element={this.Communication()}></Route>
                                <Route path="/branding" element={this.Branding()}></Route>
                            </Routes>
                        </div>
                    </>
                )}
                <Modal isOpen={this.state.showCreateModal} toggle={this.toggleCreateModal} centered={true}>
                    <ModalHeader toggle={this.toggleCreateModal}>Add Organization</ModalHeader>
                    <ModalBody>
                        <CreateOrganization></CreateOrganization>
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-secondary" onClick={this.toggleCreateModal}>
                            Done
                        </button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showCreateClientModal} toggle={this.toggleCreateClientModal} centered={true}>
                    <ModalHeader toggle={this.toggleCreateClientModal}>Add Client</ModalHeader>
                    <ModalBody>{this.state.selectedOrganization && <CreateClient organization={this.state.selectedOrganization.id}></CreateClient>}</ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-secondary" onClick={this.toggleCreateClientModal}>
                            Done
                        </button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showIdentityProviderModal} toggle={this.toggleIdentityProviderModal} centered={true}>
                    <ModalHeader toggle={this.toggleIdentityProviderModal}>Add Identity Provider</ModalHeader>
                    <ModalBody>{this.state.selectedOrganization && <CreateIdentityProvider organization={this.state.selectedOrganization.id}></CreateIdentityProvider>}</ModalBody>
                    <ModalFooter>
                        <button type="button" className="btn btn-secondary" onClick={this.toggleIdentityProviderModal}>
                            Done
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
